import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Conditional classes (clsx) with later Tailwind utilities winning over earlier
 * ones (tailwind-merge). Without the merge, a `className` passed into a
 * component would sit alongside the component's own padding rather than
 * replacing it, and which one applied would depend on stylesheet order.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export type { ClassValue };
